import React from 'react';
import { ImageTemplate } from 'themes/components';
import { observer } from 'mobx-react';

const ImageModal = observer(props => {
	return <ImageTemplate {...props} />;
});

export default ImageModal;
